import { useQuery } from '@tanstack/react-query'
import {
  listCompumaticPunches,
  ListCompumaticPunchesParams,
} from 'api/admin/timeClock/listCompumaticPunches'
import { timeClockKeys } from './keys'

export function useCompumaticPunchesQuery(params: ListCompumaticPunchesParams) {
  return useQuery({
    queryKey: timeClockKeys.compumaticPunches(params),
    queryFn: () => listCompumaticPunches(params),
  })
}
